import Vue from 'vue';
import networkErr from './networkErr.vue';
import { setStyle } from '@/utils/dom';
const NetworkErrConstructor = Vue.extend(networkErr);
let instance;

export default {
    open(options = {}) {
        if (!instance) {
            instance = new NetworkErrConstructor({
                el: document.createElement('div')
            });
        }
        if (instance.visible) return;
        document.body.appendChild(instance.$el);
        // 隐藏 loading
        let indicator = document.querySelector('.ppdai-indicator');
        indicator && setStyle(indicator, 'display', 'none');

        Vue.nextTick(() => {
            instance.visible = true;
        });
    },

    close() {
        if (instance) {
            instance.visible = false;
        }
    }
};
